var map = {
	"./01.png": "7a23",
	"./02.png": "4eaf",
	"./03.png": "284f",
	"./04.png": "5edd",
	"./05.png": "590c",
	"./06.png": "bf22",
	"./07.png": "447b",
	"./08.png": "bfab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4993";